<template>
  <div class="tw:flex tw:flex-col tw:gap-10 tw:h-full">
    <div v-if="state.loading || combos.length > 0" class="tw:flex tw:flex-col tw:md:flex-row tw:gap-4 tw:md:justify-between tw:md:items-center">
      <div class="tw:flex tw:gap-2.5 tw:items-center tw:basis-full">
        <TextPlay tag="h1" text="Combos" size="2xl" weight="semibold" color="var(--opposite-color)" />
        <IconGoogle name="inventory_2" color="var(--opposite-color)" />
      </div>
      <ButtonPlayV2 :text="$t('combos.texts.new_combo_title')" variant="filled" @click="onNewCombo" />
    </div>
    <ComboList :combos="combos" :loading="state.loading" @edit="onEdit" @delete="onDelete" @create="onNewCombo" />
  </div>
</template>

<script setup lang="ts">
import ComboList from "./components/ComboList.vue";
import { ButtonPlayV2 } from "@/components/atomic"
import { modal } from "@/events";
import { ID, play } from "@voomp/play-back";
import { ref, reactive, onMounted } from "vue";

const combos = ref<Awaited<ReturnType<typeof play.combo.list>>>([]);

const state = reactive({
  loading: false  
});

async function load() {
  state.loading = true;
  try {
    combos.value = await play.combo.list({});
  } finally {
    state.loading = false;
  }
}

function onNewCombo() {
  modal.show("ComboFormModal", {
    onCreated: () => {
      load();
    },
  });
}

function onEdit(comboId: ID) {
  modal.show("ComboFormModal", {
    comboId,
    onSaved: () => {
      load();
    },
  });
}

function onDelete(comboId: ID) {
  modal.show("ModalConfirm", {
    danger: true,
    title: "Excluir Combo",
    description: "Tem certeza que deseja excluir este combo?",
    onConfirm: async () => {
      await play.combo.remove({
        idSignature: comboId,
      });
      await load()
    },
  });
}

onMounted(() => {
  load();
})

</script>
